import React, { useState, useEffect } from 'react';
import './GuestLogin.scss';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import HongButton from '../comm/HongButton';
import KakaoLogin from './KakaoLogin';
import GoogleLogin from './GoogleLogin';
import NaverLogin from './NaverLogin';
import AppleLogin from './AppleLogin';
import { setIsLoggedIn, setUserInfo } from "../reduxToolkit/redux";
import { signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { auth } from '../page_firebase/firebaseConfig';

function GuestLogin() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const acaName = useSelector(state => state.reduxStore.acaName);
    const [loading, setLoading] = useState(false);

    const handleBack = () => {
        navigate(-1);
    };

    //======================================================================================
    return (
        <div className="guest-login">
            <div className="guest-login-container">
                <div className="header">
                    <HongButton className="back-btn" iconType={'left'} onClick={handleBack} />
                    <h1 className="title">
                        <p>비회원 로그인</p>
                    </h1>
                </div>

                <div className="social-login-section">
                    <p className="description">
                        소셜 계정으로 간편하게 로그인하세요
                    </p>

                    <div className="social-buttons">
                        <KakaoLogin loading={loading} setLoading={setLoading} />
                        <NaverLogin loading={loading} setLoading={setLoading} />
                        <GoogleLogin loading={loading} setLoading={setLoading} />
                        <AppleLogin loading={loading} setLoading={setLoading} />
                        
                    </div>

                    <div className="notice">
                        <p>소셜 로그인 시 해당 서비스 약관에 동의한 것으로 간주됩니다.</p>
                    </div>
                </div>

                {loading && (
                    <div className="loading-overlay">
                        <div className="loading-spinner"></div>
                        <p>로그인 중...</p>
                    </div>
                )}
            </div>
        </div>
    );
}

export default GuestLogin;